import { createDivIn, createImgIn, createLinkIn, setElementInnerHTML, setElementInnerText, setElementOnClick } from '../ui_utils/DomUtils.ts';
import { TimeUtils } from '@colonist/utils';
import { UINotificationSendHelper } from './UINotificationSendHelper.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
export class UINotificationItemViewBase {
    createBaseNotification(dateReceived) {
        createImgIn(this._container, this.viewData.image, 'notification_image');
        this.content = createDivIn(this._container, 'notification_content');
        this.textContainer = createDivIn(this.content, 'notification_text');
        this.timestamp = createDivIn(this.content, 'notification_timestamp');
        setElementInnerText(this.timestamp, TimeUtils.getTimeAgoTextFromDate(dateReceived));
        setElementInnerHTML(this.textContainer, this.viewData.text);
    }
    removeContentHoverEffectIfNoClickAction() {
        const hasViewDataClickAction = this.viewData.clickAction != undefined;
        const hasMarkAsReadClickAction = this.unreadNotificationIcon != undefined;
        if (hasViewDataClickAction) return;
        if (hasMarkAsReadClickAction) return;
        this.content.classList.toggle('notification_content_no_hover_effect', true);
    }
    showUnreadIconIfNeeded(dateRead) {
        const isUnread = dateRead == undefined || dateRead.getTime() >= Date.now();
        const notificationHasCTAs = this.viewData.responseButtons != undefined;
        const shouldShowUnreadCircle = isUnread && !notificationHasCTAs;
        if (shouldShowUnreadCircle) this.unreadNotificationIcon = createDivIn(this._container, 'notification_unread_icon');
    }
    createResponseButtons() {
        if (this.viewData.responseButtons == undefined) return;
        const responseButtonsContainer = createDivIn(this.content, 'notification_response_buttons');
        const acceptButton = createDivIn(responseButtonsContainer, 'notification_response_button btn_general');
        setElementInnerHTML(acceptButton, {
            key: 'strings:colonistCommon.buttons.accept'
        });
        setElementOnClick(acceptButton, ()=>{
            var _this_viewData_responseButtons;
            this.callbackOnClick();
            (_this_viewData_responseButtons = this.viewData.responseButtons) === null || _this_viewData_responseButtons === void 0 ? void 0 : _this_viewData_responseButtons.acceptButtonAction();
        });
        const ignoreButton = createDivIn(responseButtonsContainer, 'notification_response_button notification_ignore_button btn_general');
        setElementInnerHTML(ignoreButton, {
            key: 'strings:colonistCommon.buttons.ignore'
        });
        setElementOnClick(ignoreButton, ()=>{
            var _this_viewData_responseButtons;
            this.callbackOnClick();
            (_this_viewData_responseButtons = this.viewData.responseButtons) === null || _this_viewData_responseButtons === void 0 ? void 0 : _this_viewData_responseButtons.ignoreButtonAction();
        });
    }
    setCallbackOnClick(callback) {
        this.callbackOnClick = callback;
    }
    setClickActions() {
        const notificationHasCTAs = this.viewData.responseButtons != undefined;
        const contentClickAction = (e)=>{
            var _this_viewData_clickAction, _this_viewData;
            if (UIUtilsEjsVariables.isUserOnDiscord) e.preventDefault();
            if (!notificationHasCTAs) UINotificationSendHelper.sendMarkNotificationAsRead(this.notificationId);
            (_this_viewData_clickAction = (_this_viewData = this.viewData).clickAction) === null || _this_viewData_clickAction === void 0 ? void 0 : _this_viewData_clickAction.call(_this_viewData);
        };
        if (this.unreadNotificationIcon) {
            setElementOnClick(this.unreadNotificationIcon, ()=>{
                if (!notificationHasCTAs) UINotificationSendHelper.sendMarkNotificationAsRead(this.notificationId);
            });
        }
        if (this.viewData.secondaryLink == undefined) return;
        const link = createLinkIn(this.content, this.viewData.secondaryLink.url, this.viewData.secondaryLink.text, 'notification_link', '', this.viewData.secondaryLink.openNewTab);
        setElementOnClick(link, contentClickAction);
    }
    get dateReceived() {
        return this._dateReceived;
    }
    get container() {
        return this._container;
    }
    get notificationId() {
        return this._notificationId;
    }
    get isRead() {
        return this.unreadNotificationIcon == undefined;
    }
    get hasCTAs() {
        return this.viewData.responseButtons != undefined;
    }
    removeUnreadIcon() {
        if (this.unreadNotificationIcon == undefined) return;
        this.unreadNotificationIcon.remove();
    }
    updateTimestamp() {
        setElementInnerText(this.timestamp, TimeUtils.getTimeAgoTextFromDate(this.dateReceived));
    }
    constructor(id, dateReceived, parentContainer){
        const notificationItem = createDivIn(parentContainer, 'notification_item');
        this._container = notificationItem;
        this._dateReceived = dateReceived;
        this._notificationId = id;
    }
}
